jPar.util = jPar.util || {};
deepMerge(true, jPar.util, {
	log: {
		error: function error(detailedInformation, highlevelInformation) {
			try {
				// Falls tracking mal schief geht soll alles andere weiterlaufen können
				const detailedInformationText = typeof detailedInformation === 'object' ? JSON.stringify(detailedInformation) : detailedInformation.toString();
				console.trace(
					'%c----CAUGHT ERROR: ' + detailedInformationText + ' -> ' + highlevelInformation.toString() + ' ----',
					'color: red; font-size: 14px;',
				); // NOSONAR

				const customEvent = new CustomEvent('pegLogger-logJsError', {
					detail: {
						message: detailedInformation,
						stacktrace: highlevelInformation.toString(),
						origin: 'Caught_JSError',
					},
				});
				document.dispatchEvent(customEvent);
			} catch {
				console.error('call of jPar.util.log.error() failed');
			}
		},

		ux: function (detailedInformation, highlevelInformation) {
			console.log('%c----UX: ' + detailedInformation + ' -> ' + highlevelInformation.toString() + ' ----', 'color: blue; font-size: 14px;'); // NOSONAR

			const customEvent = new CustomEvent('pegLogger-logJsError', {
				detail: {
					message: detailedInformation,
					stacktrace: highlevelInformation.toString(),
					origin: 'UXLogging',
				},
			});
			document.dispatchEvent(customEvent);
		},

		/**
		 * @typedef {{category: string, subcategory: string, action: string, targetId: string, cd1: string, cd2: string, cd3: string, cd4: string, cd5: string,cd6: string}} logData
		 */
		/**
		 * @param {Partial<logData>} logData
		 */
		bigData: function (logData) {
			//TODO if supported in Safari 17. We have a shim here
			window.requestIdleCallback(
				() => {
					const customEvent = new CustomEvent('pegLogger-logWebAppEvents', { detail: logData });
					document.dispatchEvent(customEvent);
				},
				{ timeout: 100 },
			);
		},

		// Der einzig legitime Weg um dauerhaft Sachen in die Konsole zu schreiben.
		// console.log sollte ansonsten nur zu debug-zwecken benuzt werden.
		// Am Ende der Feature Entwicklung console.log Ausgaben immer aus den JS Dateien löschen.
		devConsole: function devConsole(output) {
			if ($j('#domPageVars').length > 0) {
				const isDevSystem = $j('#domPageVars').data('isDevSystem') !== undefined || document.location.href.indexOf('.dev') > -1;
				if (isDevSystem) {
					console.log(output); // NOSONAR
					document.querySelector('bst-opener')?.appLogging(output);
				}
			}
		},
	},
});
